import React from "react";

function Skel({ className = "", style }) {
  return (
    <span
      className={`company-forms-skeleton-block ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
}

export function CompanyFormsStatsSkeleton({ cards = 2 }) {
  return (
    <div className="company-forms-stats-grid" aria-busy="true" aria-label="Loading statistics">
      {[...Array(cards)].map((_, i) => (
        <div key={`cf-stat-skel-${i}`} className="company-forms-skeleton-stat-card">
          <Skel className="company-forms-skeleton-stat-icon" />
          <div className="company-forms-skeleton-stat-text">
            <Skel className="company-forms-skeleton-stat-value" />
            <Skel className="company-forms-skeleton-stat-label" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function CompanyFormsFiltersSkeleton() {
  return (
    <div className="company-forms-skeleton-filters" aria-hidden="true">
      <div className="company-forms-skeleton-filters-row">
        <Skel className="company-forms-skeleton-search" />
        <Skel className="company-forms-skeleton-select" />
        <Skel className="company-forms-skeleton-select" />
      </div>
    </div>
  );
}

function CompanyFormsLibraryCardSkeleton() {
  return (
    <div className="company-forms-skeleton-library-card">
      <div className="company-forms-skeleton-library-card-top">
        <Skel className="company-forms-skeleton-library-icon" />
        <Skel className="company-forms-skeleton-line--badge" />
      </div>
      <Skel className="company-forms-skeleton-line--heading" />
      <Skel className="company-forms-skeleton-line--body" />
      <Skel className="company-forms-skeleton-line--body-short" />
      <Skel className="company-forms-skeleton-library-btn" />
    </div>
  );
}

export function CompanyFormsLibraryGridSkeleton({ count = 8 }) {
  return (
    <div className="company-forms-library-grid company-forms-skeleton-library-grid" aria-hidden="true">
      {[...Array(count)].map((_, i) => (
        <CompanyFormsLibraryCardSkeleton key={`cf-lib-skel-${i}`} />
      ))}
    </div>
  );
}

export function CompanyFormsManageTableSkeleton({ rows = 6 }) {
  return (
    <div className="company-forms-skeleton-table-card" aria-hidden="true">
      <div className="company-forms-skeleton-table-head company-forms-skeleton-table-head--5">
        {[...Array(5)].map((_, i) => (
          <Skel key={`cf-th-${i}`} className="company-forms-skeleton-table-th" />
        ))}
      </div>
      {[...Array(rows)].map((_, row) => (
        <div
          key={`cf-tr-${row}`}
          className="company-forms-skeleton-table-row company-forms-skeleton-table-row--5"
        >
          <div>
            <Skel className="company-forms-skeleton-line--cell-title" />
            <Skel className="company-forms-skeleton-line--cell-sub" />
          </div>
          <Skel className="company-forms-skeleton-pill" />
          <Skel className="company-forms-skeleton-pill company-forms-skeleton-pill--category" />
          <Skel className="company-forms-skeleton-pill" />
          <Skel className="company-forms-skeleton-action-btn company-forms-skeleton-action-btn--icon" />
        </div>
      ))}
    </div>
  );
}

export function CompanyFormsManagePageSkeleton({ showPendingBanner = false }) {
  return (
    <>
      <CompanyFormsStatsSkeleton cards={2} />
      {showPendingBanner ? (
        <span
          className="company-forms-skeleton-block company-forms-skeleton-pending-banner"
          aria-hidden="true"
        />
      ) : null}
      <CompanyFormsManageTableSkeleton rows={6} />
    </>
  );
}

export function CompanyFormsApproveInboxSkeleton() {
  return (
    <div className="flex flex-col gap-5" aria-hidden="true">
      <span className="company-forms-skeleton-block h-10 w-full rounded-lg" />
      <div className="company-forms-approve-inbox-grid">
        <span className="company-forms-skeleton-block h-[9.5rem] w-full min-w-0 rounded-xl" />
        <span className="company-forms-skeleton-block h-[9.5rem] w-full min-w-0 rounded-xl" />
        <span className="company-forms-skeleton-block h-[9.5rem] w-full min-w-0 rounded-xl" />
        <span className="company-forms-skeleton-block h-[9.5rem] w-full min-w-0 rounded-xl" />
      </div>
    </div>
  );
}

export function CompanyFormsLibraryPageSkeleton() {
  return (
    <>
      <CompanyFormsStatsSkeleton cards={2} />
      <CompanyFormsFiltersSkeleton />
      <CompanyFormsLibraryGridSkeleton count={8} />
    </>
  );
}
